export default {
    key: 'eigergletscher',
    type: 'P2P',
    isUsingProductConfigPresets: false,
    isUsingProductPresets: true,
    hideCrossSells: false,
    disablePassengers: false,
    origins: [],
    destinations: [{
        ref: 'urn:uic:stn:8507361',
        name: 'Eigergletscher',
    }],
    returnOrigins: [],
    returnDestinations: [],
    isRoundtrip: 'optional',
    canSwitchDirection: true,
    canChooseReturnDestination: false,
    isUsingReductionCards: true,
    isUsingKeyCards: false,
    isUsingPromos: true,
    isPromotionRequired: false,
    hasEPR: false,
    routeVariants: ['express', 'traditional-grin', 'traditional-laut'],
    routeVariantUp: 'default-eigergletscher',
    routeVariantDown: 'default-eigergletscher',
    upsells: [],
    isUpsellDatesRestricted: false,
    isUsingSeasonDates: false,
    departureTimeIteration: 30,
    departureTimeDefaultMin: 420,
    stayDurationIteration: 30,
    stayDurationPopular: 120,
    stayDurationMin: 60,
    salesTimeLimit: 1115, // 18:35
    maxNumberOfPeople: 10,
    maxNumberOfPeopleGroupTariff: 10,
    defaultPassengerAge: 30,
    hiddenProductReductionCard: undefined,
    listingId: 'urn:listing:trips:eigergletscher',
    isLocalListing: true,
    steps: [
        {
            routeName: 'offerFlow-eigergletscher-steps-step-1-date',
            name: 'offerFlow.pages.stepDate.name.common',
        },
        {
            routeName: 'offerFlow-eigergletscher-steps-step-2-trip-selection',
            name: 'offerFlow.pages.stepTripSelection.name.common',
        },
        {
            routeName: 'offerFlow-eigergletscher-steps-step-4-passengers',
            name: 'offerFlow.pages.stepPassengers.name.common',
            skipIfUpsell: true,
        },
    ],
} satisfies ProductConfigP2P;
